//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

/**
 * This file contains sample data that serves as a template for users to understand
 * the expected format of the bulk upload CSV. This is intentionally mock data and
 * will be used as a downloadable example for users, not for actual API responses.
 */

import { BulkUploadSamplingProduct } from '@campaigns/types/sampling/SamplingBulkUploadTypes';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

export const BULK_UPLOAD_SAMPLE_DATA: BulkUploadSamplingProduct[] = [
  {
    name: 'Desk Lamp',
    targetCatalogProductId: 'desk-lamp-1234',
    brand: 'Example Store',
    category: 'Home & Garden',
    description: 'Adjustable LED desk lamp.',
    pdpUrl: 'https://examplestore.com/desk-lamp',
    imgUrl: 'https://images.examplestore.com/desk-lamp.jpg',
    shippingAvailabilityDate: DateString.addDays(
      DateString.getToday(TimeZoneId.Utc),
      1,
    ),
    destinationGTIN: '041800000265, 688598900584',
    variantName: 'Default',
    variantImgUrl: 'https://images.examplestore.com/desk-lamp.jpg',
    variantQuantity: 150,
    variantFairMarketValue: 3500.5,
    variantLogisticsRef: '688598900577',
    dimensionsFormat: 'CM',
    dimensionsDepth: 10,
    dimensionsWidth: 10,
    dimensionsHeight: 10,
  },
  {
    name: 'Travel Mug',
    targetCatalogProductId: 'travel-mug-1234',
    brand: 'Example Store',
    category: 'Home & Garden',
    description: 'Insulated travel mug.',
    pdpUrl: 'https://examplestore.com/travel-mug',
    imgUrl: 'https://images.examplestore.com/travel-mug.jpg',
    shippingAvailabilityDate: DateString.addDays(
      DateString.getToday(TimeZoneId.Utc),
      1,
    ),
    destinationGTIN: '688598900560, 688598900614',
    variantName: '12oz',
    variantImgUrl: 'https://images.examplestore.com/travel-mug-12oz.jpg',
    variantQuantity: 100,
    variantFairMarketValue: 2000.8,
    variantLogisticsRef: '688598900607',
    dimensionsFormat: 'CM',
    dimensionsDepth: 10,
    dimensionsWidth: 10,
    dimensionsHeight: 10,
  },
  {
    name: 'Travel Mug',
    targetCatalogProductId: 'travel-mug-1234',
    brand: 'Example Store',
    category: 'Home & Garden',
    description: 'Insulated travel mug.',
    pdpUrl: 'https://examplestore.com/travel-mug',
    imgUrl: 'https://images.examplestore.com/travel-mug.jpg',
    shippingAvailabilityDate: DateString.addDays(
      DateString.getToday(TimeZoneId.Utc),
      1,
    ),
    destinationGTIN: '688598900591, 688598900638',
    variantName: '16oz',
    variantImgUrl: 'https://images.examplestore.com/travel-mug-16oz.jpg',
    variantQuantity: 200,
    variantFairMarketValue: 2200.7,
    variantLogisticsRef: '688598900621',
    dimensionsFormat: 'CM',
    dimensionsDepth: 10,
    dimensionsWidth: 10,
    dimensionsHeight: 10,
  },
];
